import { useParams } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { useGPUInstanceStore } from '@/store/gpu-instance';
import { Trash2 } from 'lucide-react';

const GPUInstanceDetailSettings = () => {
  const { instanceId } = useParams<{ instanceId: string }>();
  const { instances, currentInstance } = useGPUInstanceStore();

  const instance = currentInstance || instances.find((i) => i.task_id === instanceId);

  if (!instance) {
    return (
      <div className="container py-8">
        <Alert>
          <AlertDescription>
            Instance not found.
          </AlertDescription>
        </Alert>
      </div>
    );
  }

  return (
    <div className="container py-8">
      <div className="mb-6">
        <h1 className="text-2xl font-bold">Instance Settings</h1>
        <p className="text-muted-foreground mt-1">
          Manage settings for this GPU instance
        </p>
      </div>

      <div className="space-y-6">
        <Card>
          <CardHeader>
            <CardTitle>Instance Information</CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="flex items-center justify-between">
              <span className="text-sm text-muted-foreground">Task ID</span>
              <code className="text-sm bg-muted px-2 py-1 rounded">
                {instance.task_id}
              </code>
            </div>
          </CardContent>
        </Card>

        <Card className="border-destructive">
          <CardHeader>
            <CardTitle className="text-destructive">Danger Zone</CardTitle>
            <CardDescription>
              Irreversible actions for this instance
            </CardDescription>
          </CardHeader>
          <CardContent>
            <div className="flex items-center justify-between">
              <div>
                <p className="font-medium">Terminate Instance</p>
                <p className="text-sm text-muted-foreground">
                  Permanently delete this instance and all associated data
                </p>
              </div>
              <Button variant="destructive">
                <Trash2 className="size-4 mr-2" />
                Terminate
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default GPUInstanceDetailSettings;
